require('../modules/web.immediate');
module.exports = require('../modules/_core').setImmediate;



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/set-immediate.js
// module id = 360
// module chunks = 2